import { createClient as createSupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@weiro/types/database";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

export const supabase = createSupabaseClient<Database>(
  supabaseUrl,
  supabaseKey,
  {
    auth: {
      detectSessionInUrl: false,
      flowType: "pkce",
    },
  },
);
